import { usePWA } from '@/hooks/usePWA';

export function UpdateBanner() {
  const { updateAvailable, applyUpdate } = usePWA();

  if (!updateAvailable) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-emerald-600 text-white flex items-center justify-between px-4 py-2.5 text-sm font-medium shadow-lg">
      <span>🔄 New version available</span>
      <button
        onClick={applyUpdate}
        className="bg-white text-emerald-700 font-semibold px-3 py-1 rounded-md text-xs hover:bg-emerald-50 transition-colors"
      >
        Update
      </button>
    </div>
  );
}
